import { AlertTriangle, ShieldAlert } from "lucide-react";

export function SafetyNotice({ compact = false }: { compact?: boolean }) {
  return (
    <aside className={`safety-notice ${compact ? "compact" : ""}`} aria-label="Experimental software warning">
      <div className="safety-icon" aria-hidden="true">{compact ? <AlertTriangle /> : <ShieldAlert />}</div>
      <div>
        <strong>Experimental test software — use at your own risk.</strong>
        <p>
          Blockr is free and open source, but it carries no forensic-assurance, accreditation,
          admissibility, completeness, or warranty claim. It is not a hardware or software write
          blocker. Use it only on media you are authorized to examine, with tested write-blocking
          where preservation matters.
        </p>
      </div>
    </aside>
  );
}
